import { cn } from '@/lib/utils';
import { useRef, useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog';
import NotifyForm from './NotifyForm';

const NotifyMeDialog = props => {
  const {
    open,
    onSetOpen,
    product_id,
    variants,
    selectedOptionsArray,
    configurable_options,
    productDetailsName,
    productSku,
  } = props;

  const [isSubmitOk, setIsSubmitOk] = useState(true);

  const prevPropsRef = useRef({ open });

  if (prevPropsRef.current.open !== open) {
    prevPropsRef.current.open = open;

    if (open) {
      setIsSubmitOk(false);
    }
  }

  return (
    <Dialog
      open={open}
      onOpenChange={() => {
        onSetOpen(false);
      }}
    >
      <DialogTitle className='hidden'>notify me</DialogTitle>
      <DialogContent
        showCloseButton={false}
        className={cn('lg_w-max-[600px] h-full max-h-full w-full overflow-auto p-0 lg_h-auto', isSubmitOk && 'h-auto')}
        aria-description={undefined}
      >
        <NotifyForm
          onClose={() => {
            onSetOpen(false);
          }}
          isSubmitOk={isSubmitOk}
          setIsSubmitOk={setIsSubmitOk}
          product_id={product_id}
          variants={variants}
          selectedOptionsArray={selectedOptionsArray}
          configurable_options={configurable_options}
          productDetailsName={productDetailsName}
          productSku={productSku}
        />
      </DialogContent>
    </Dialog>
  );
};

export default NotifyMeDialog;
